import { AwsRum, AwsRumConfig } from "aws-rum-web";

const config: AwsRumConfig = {
  sessionSampleRate: 1,
  guestRoleArn:
    "arn:aws:iam::676466704749:role/RUM-Monitor-us-east-1-676466704749-3521769329661-Unauth",
  identityPoolId: "us-east-1:35305b1c-c8eb-4137-bb04-2ef1414ebe51",
  endpoint: "https://dataplane.rum.us-east-1.amazonaws.com",
  telemetries: ["performance", "errors", "http"],
  allowCookies: false,
  enableXRay: false,
  enableRumClient: !!process.env.REACT_APP_ENV && process.env.REACT_APP_ENV !== "dev",
};

const APPLICATION_ID: string = "ef2c1530-4388-46f5-b957-b299d9fc3a22";
const APPLICATION_VERSION: string = process.env.REACT_APP_COMMIT ?? "NA";
const APPLICATION_REGION: string = "us-east-1";

export let awsRum: AwsRum;

export function initAwsRum() {
  try {
    awsRum = new AwsRum(APPLICATION_ID, APPLICATION_VERSION, APPLICATION_REGION, config);
    awsRum.addSessionAttributes({ env: process.env.REACT_APP_ENV ?? "NA" });
  } catch (error) {
    console.error(error);
  }
}
